<template>
    <section class="doc-section">

        <!-- Al inicio, dentro de <section> -->
        <div class="mb-6">
            <BotonesNavegacion @cambio-plataforma="plataformaActual = $event" />
        </div>

        <header class="header-container">
            <h1>Modificar Geocerca</h1>
            <p class="description">
                En la tabla de geocercas, al hacer clic sobre el botón de editar, se mostrará la vista de edición.
            </p>
        </header>

        <div class="two-col">
            <div class="col-steps">
                <p class="steps-label">Interacción y Controles</p>

                <div class="step-card">
                    <div class="step-badge">1</div>
                    <div>
                        <div class="step-title">Editar Geocerca</div>
                        <div class="step-desc">Permite modificar la geocerca previamente dibujada sobre el mapa mediante controles directos.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge">2</div>
                    <div>
                        <div class="step-title">Pantalla completa</div>
                        <div class="step-desc">Expande el mapa a las dimensiones totales de la pantalla para mejor visualización.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge">3</div>
                    <div>
                        <div class="step-title">Zoom In (+)</div>
                        <div class="step-desc">Permite acercar la vista del mapa para ver detalles del trazado.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge">4</div>
                    <div>
                        <div class="step-title">Zoom Out (-)</div>
                        <div class="step-desc">Permite alejar la vista del mapa para observar el contexto general.</div>
                    </div>
                </div>

                <div class="step-card">
                    <div class="step-badge">5</div>
                    <div>
                        <div class="step-title">Ver Formulario</div>
                        <div class="step-desc">Permite desplegar el formulario de la geocerca.</div>
                    </div>
                </div>
            </div>

            <!-- En el Carrusel Principal -->
            <div class="col-image">
                <div class="carousel-box">
                    <transition name="fade" mode="out-in">
                        <CarruselAciqui :key="plataformaActual" :items="imagenesPrincipalMostrar" />
                    </transition>
                </div>
            </div>
        </div>

        <div class="section-divider">
            <h2>Métodos de ajuste en mapa</h2>
        </div>

        <!-- En el Carrusel de Métodos de ajuste -->
        <div class="carousel-box">
            <transition name="fade" mode="out-in">
                <CarruselAciqui :key="plataformaActual" :items="imagenesEdicionMapaMostrar" />
            </transition>
        </div>

        <div class="methods-grid">
            <div class="method-card">
                <div class="method-icon">A</div>
                <h4>Geocerca circular</h4>
                <ul class="sub-list">
                    <li><strong>a)</strong> Arrastre el cuadrado en la circunferencia para ajustar el <strong>radio</strong>.</li>
                    <li><strong>b)</strong> Arrastre el cuadrado central para modificar la <strong>ubicación</strong>.</li>
                    <li><strong>c)</strong> Use los botones Guardar o Cancelar para procesar los cambios.</li>
                </ul>
            </div>
            <div class="method-card">
                <div class="method-icon">B</div>
                <h4>Geocerca poligonal</h4>
                <ul class="sub-list">
                    <li><strong>a)</strong> Arrastre cualquier vértice para aumentar o reducir el <strong>tamaño</strong>.</li>
                    <li><strong>b)</strong> Arrastre los puntos intermedios para agregar un <strong>nuevo vértice</strong>.</li>
                    <li><strong>c)</strong> Use los botones Guardar o Cancelar para procesar los cambios.</li>
                </ul>
            </div>
        </div>

        <div class="section-divider">
            <h2>Campos del formulario de edición</h2>
        </div>

        <div class="carousel-box">
            <!-- Reemplazamos la etiqueta <img> por el carrusel -->
            <transition name="fade" mode="out-in">
                <CarruselAciqui 
                    :key="plataformaActual" 
                    :items="imagenesFormularioMostrar" 
                />
            </transition>
        </div>

        <div class="form-grid">
            <div class="field-row">
                <span class="field-key">A</span>
                <div><div class="field-label">Nombre</div><div class="field-desc">Identificador de la geocerca</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">F</span>
                <div><div class="field-label">Color</div><div class="field-desc">Tono visual de la geocerca</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">B</span>
                <div><div class="field-label">Radio</div><div class="field-desc">Distancia del centro a la orilla (solo circular)</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">G</span>
                <div><div class="field-label">Alerta</div><div class="field-desc">Opciones: "Entrada", "Salida" o "Ambos"</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">C</span>
                <div><div class="field-label">Medida</div><div class="field-desc">Unidad de distancia (Metros / Kilómetros)</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">H</span>
                <div><div class="field-label">Asignar dispositivo</div><div class="field-desc">Listado de activos vinculados</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">D</span>
                <div><div class="field-label">Latitud</div><div class="field-desc">Coordenada del centro (editable manualmente)</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">I</span>
                <div><div class="field-label">Cancelar</div><div class="field-desc">Regresa a la vista de geocercas sin guardar</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">E</span>
                <div><div class="field-label">Longitud</div><div class="field-desc">Coordenada del centro (editable manualmente)</div></div>
            </div>
            <div class="field-row">
                <span class="field-key">J</span>
                <div><div class="field-label">Guardar geocerca</div><div class="field-desc">Aplica cambios y regresa al listado</div></div>
            </div>
        </div>

        <div class="doc-note note-danger">
            <svg class="note-icon" width="15" height="15" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                <path d="M8 5v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="8" cy="10.5" r="0.75" fill="currentColor"/>
            </svg>
            <div class="note-body">
                <span class="note-label">Nota importante</span>
                <p>El formulario de la geocerca <strong>poligonal</strong> no cuenta con los campos radio, medida, latitud, y longitud.</p>
            </div>
        </div>

        <!-- Busca esto al final de tu template -->
        <footer class="success-section">
        <p>Al guardar los cambios exitosamente, se mostrará la siguiente notificación:</p>
        
        <div class="carousel-box success-carousel">
            <transition name="fade" mode="out-in">
                <!-- Usamos el componente para asegurar el ajuste de tamaño -->
                <CarruselAciqui 
                    :key="plataformaActual" 
                    :items="imagenesExitoMostrar" 
                />
            </transition>
        </div>
    </footer>

    </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import CarruselAciqui from '../Carruselimg.vue';
import BotonesNavegacion from '../BotonesNavegacion.vue';

const plataformaActual = ref('web');

// --- DATOS WEB ---
const webData = {
    principal: [{ nombre: "Vista de Edición", url: '/img/adminGeocercas/Editar_Geocerca_Principal.png', descripcion: "Interfaz principal del módulo de edición." }],
    mapa: [
        { nombre: "Edición Geocerca Circular", url: "/img/adminGeocercas/Edicion_Mapa_Circular.png", descripcion: "Ajuste de radio y posición mediante controles en mapa" },
        { nombre: "Edición Geocerca Poligonal", url: "/img/adminGeocercas/Edicion_Mapa_Poligonal.png", descripcion: "Ajuste de vértices y forma del polígono." },
    ],
    formulario: [
        {
            nombre: "Formulario de Edición", url: "/img/adminGeocercas/Formulario_Edicion.png", descripcion: "Permite desplegar y modificar los parámetros alfanuméricos de la geocerca."
        }
    ],
    exito: [
        { 
            nombre: "Notificación de éxito", 
            url: '/img/adminGeocercas/Notificacion_Exito.png', 
            descripcion: "Confirmación visual de cambios guardados." 
        }
    ]
};

// --- DATOS MÓVIL ---
const mobileData = {
    principal: [{ nombre: "Vista de Edición", url: '/img/adminGeocercas/VistaEdicion_Movil.png', descripcion: "Interfaz principal del módulo de edición." }],
    mapa: [
        { nombre: "Edición Geocerca Circular", url: "/img/adminGeocercas/EditarGeocerca_Ciruclar_Movil.png", descripcion: "Ajuste de radio y posición mediante controles en mapa" },
        { nombre: "Edición Geocerca Poligonal", url: "/img/adminGeocercas/EditarGeocerca_Poligonal_Movil.png", descripcion: "Ajuste de vértices y forma del polígono." }
    ],
    formulario: [
        {
            nombre: "Formulario de Edición", url: "/img/adminGeocercas/Formulario_Edicion_Geocerca_Movil.png", descripcion: "Permite desplegar y modificar los parámetros alfanuméricos de la geocerca."
        }
    ],
    exito: [
        { 
            nombre: "Notificación de éxito", 
            url: '/img/adminGeocercas/Notificacion_Exito.png', 
            descripcion: "Confirmación visual de cambios guardados." 
        }
    ]
};

// --- LÓGICA COMPUTADA ---
const imagenesPrincipalMostrar = computed(() => plataformaActual.value === 'web' ? webData.principal : mobileData.principal);
const imagenesEdicionMapaMostrar = computed(() => plataformaActual.value === 'web' ? webData.mapa : mobileData.mapa);
const imagenesFormularioMostrar = computed(() => plataformaActual.value === 'web' ? webData.formulario : mobileData.formulario);
const imagenesExitoMostrar = computed(() => plataformaActual.value === 'web' ? webData.exito : mobileData.exito);</script>

<style scoped>
.mb-6 { margin-bottom: 2rem; }

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.section-title-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px; /* Espacio debajo del título */
}

/* Este le da el color azul y el grosor */
.section-title-bar h2 {
    font-size: 20px;
    font-weight: 700;
    color: var(--primary-color); /* Aquí es donde toma el azul */
    margin: 0;
}

/* ── Base ─────────────────────────────────────────── */
.doc-section {
    padding: 20px;
    background: var(--bg-color);
}

.description, .main-desc {
    font-size: 15px;
    opacity: 0.8;
    margin-bottom: 24px;
}

/* ── Layout dos columnas ──────────────────────────── */
.two-col {
    display: flex;
    gap: 24px;
    align-items: flex-start;
    margin-bottom: 28px;
}

.col-steps { flex: 1; }
.col-image  { flex: 1; position: sticky; top: 20px; }

/* ── Pasos (Cards) ────────────────────────────────── */
.steps-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: var(--primary-color);
    margin-bottom: 12px;
}

.step-card {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 10px;
    transition: all 0.2s ease;
}

.step-card:hover { border-color: var(--primary-color); }

.step-badge {
    min-width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--primary-color);
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.step-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
}

.step-desc {
    font-size: 13px;
    opacity: 0.8;
    line-height: 1.5;
}

/* ── Separadores ──────────────────────────────────── */
.section-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 32px 0 16px;
}

.section-divider h2 {
    font-size: 20px;
    font-weight: 700;
    color: var(--primary-color); /* Aquí es donde toma el azul */
    margin: 0;
}

.divider-line { flex: 1; height: 1px; background: var(--border-color); }

/* ── Métodos Grid ─────────────────────────────────── */
.methods-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-top: 16px;
}

.method-card {
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 16px;
}

.method-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--primary-color);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    margin-bottom: 12px;
}

.sub-list {
    list-style: none;
    padding: 0;
    margin: 10px 0 0;
    font-size: 13px;
    opacity: 0.8;
}

.sub-list li { margin-bottom: 6px; }

/* ── Formulario Grid ──────────────────────────────── */
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin: 20px 0;
}

.field-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 10px 12px;
}

.field-key {
    font-weight: 700;
    color: var(--primary-color);
    font-size: 14px;
}

.field-label { font-weight: 600; font-size: 13px; }
.field-desc { font-size: 12px; opacity: 0.6; }

/* ── Notas y Éxito ────────────────────────────────── */
.doc-note {
    display: flex;
    gap: 12px;
    padding: 16px;
    border-radius: 8px;
    margin-top: 20px;
    border: 1px solid #dc2626;
    background: #fff1f2;
    color: #7f1d1d;
}

.note-label { font-weight: 700; text-transform: uppercase; font-size: 11px; display: block; }

/* ── Éxito ────────────────────────────────────────── */
.success-section {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
    text-align: center;
}

.success-section p {
    font-size: 14px;
    opacity: 0.75;
    margin-bottom: 15px;
}

/* Contenedor centrado y con tamaño controlado para la notificación */
.success-carousel {
    max-width: 700px; /* Antes era 400px */
    margin: 12px auto 0;
}

.img-fluid-rounded { 
    width: 100%; 
    height: auto;
    border-radius: 6px; 
    display: block;
}

.carousel-box :deep(img) {
    width: 100%;
    height: auto;
    display: block;
}

.img-fluid-rounded { width: 100%; border-radius: 6px; }
.img-success { max-width: 350px; border-radius: 6px; }

/* ── Responsive ───────────────────────────────────── */
@media (max-width: 768px) {
    .two-col, .form-grid, .methods-grid { grid-template-columns: 1fr; flex-direction: column; }
}
</style>